import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import ApiUrls from "../../../Utils/axr";
import { errorConditionGTM } from "../../../Utils/googleTags";

type changeFlowContentInitialState = {
  changeFlowContent: any;
  loading: boolean;
  error: any;
};
const initialState: changeFlowContentInitialState = {
  changeFlowContent: null,
  loading: false,
  error: null,
};
const host = window?.location?.host;
const file = 'change-flow-content.json'

export const getChangeFlowContent = createAsyncThunk(
  "get/change-flow-content/content",
  async () => {
    try {
      const response = await useFetchAemBrspdContents({
        [ApiUrls.aem_content]: `${file}?appName=${host}`,
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

const changeFlowContentDetailSlice = createSlice({
  name: "change-flow-content/Details",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getChangeFlowContent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getChangeFlowContent.fulfilled, (state, action) => {
      state.changeFlowContent = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getChangeFlowContent.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "change-flow-content",
        action.error?.message,
        action?.type
      );
      state.changeFlowContent = null;
      state.loading = false;
      state.error = action.error;
    });
  },
});

export default changeFlowContentDetailSlice.reducer;